var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#25d366;}.cls-2,.cls-3{fill:#fff;}.cls-3{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WhatsApp"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    className: "cls-1",
    cx: 107.5,
    cy: 107.5,
    r: 107.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "WhatsApp-2",
    "data-name": "WhatsApp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "WhatsApp-3",
    "data-name": "WhatsApp",
    className: "cls-2",
    d: "M885.91,161l7.55-27.56a53.18,53.18,0,1,1,46.09,26.64h0a53.18,53.18,0,0,1-25.41-6.48Zm29.5-17,1.62,1a44.21,44.21,0,0,0,22.5,6.17h0a44.22,44.22,0,1,0-37.45-20.72l1,1.67-4.47,16.31Z",
    transform: "translate(-831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WhatsApp-4",
    "data-name": "WhatsApp",
    className: "cls-3",
    d: "M966.34,119.54c-.33-.56-1.22-.89-2.55-1.55s-7.86-3.88-9.08-4.33-2.1-.66-3,.67-3.43,4.32-4.2,5.21-1.56,1-2.88.33A36.31,36.31,0,0,1,934,113.28a40,40,0,0,1-7.39-9.21c-.78-1.33-.09-2,.58-2.71s1.33-1.56,2-2.33a8.84,8.84,0,0,0,1.33-2.22,2.47,2.47,0,0,0-.11-2.33c-.33-.66-3-7.2-4.1-9.86s-2.17-2.24-3-2.29-1.66,0-2.54,0A4.89,4.89,0,0,0,917.17,84,14.91,14.91,0,0,0,912.52,95c0,6.54,4.76,12.86,5.43,13.75s9.37,14.31,22.7,20.06a75.55,75.55,0,0,0,7.58,2.8,18.27,18.27,0,0,0,8.37.53c2.55-.38,7.86-3.22,9-6.32S966.67,120.09,966.34,119.54Z",
    transform: "translate(-831)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/WhatsApp.0640b82bc8218ba8746b381d3ca6f0fd.svg";
export { ForwardRef as ReactComponent };